<div [class]="'s-' + size + ' level-circle ' + extraClass + ' ' + extraDutchCssClass"  [style.transform]="'scale(' + scale + ')'">
    <span [class]="'capitalize font-' + (textSize ? textSize : size)">{{name}}</span>
</div>